import "./upload-dnm-list.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {keyed}                  from "@Common/react/keyed";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {UseState}               from "@Common/react/use-state";

import {ConfirmCancel} from "../../create-mailing-list-modal/types/common/confirm-cancel";

import {Step1Upload}     from "./step-1-upload/step-1-upload";
import {Step2Build}      from "./step-2-build/step-2-build";
import {Step3CassResult} from "./step-3-cass-result/step-3-cass-result";

export const UploadDnmList = ({onClose, countryCode, onCancel, officeId, next}) => cs(
    consumeContext("apis"),
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ["data", (_, next) => UseState({
        initValue: {
            info: {
                alternateName: {
                    type: "owner",
                }
            },
        },
        next,
    })],
    ({confirmCancel, data}) => next({
        onPassiveClose: data.value.upload && !data.value.created && confirmCancel,
        content: (
            !data.value.created ? (
                !data.value.upload ? cs(
                    keyed("step1"),
                    () => Step1Upload({
                        countryCode,
                        onNext: (upload) => {
                            stateChangeNestedValue(data, ["upload"], () => upload);
                        },
                        onCancel,
                    })
                ) : cs(
                    ["step", (_, next) => UseState({initValue: 0, next})],
                    ({step}) => step.value === 0 ? cs(
                        keyed("step2"),
                        () => Step2Build_1({
                            countryCode,
                            data, onClose,
                            onNext: () => step.change(v=>v+1),
                        })
                    ) : cs(
                        keyed("step3"),
                        () => Step3({
                            data,
                            officeId,
                            onClose: () => {
                                onClose();
                            },
                            countryCode,
                        })
                    )
                )
            ) : ""
        )
    }),
);

const Step2Build_1 = ({data, onClose, countryCode, onNext}) => Step2Build({
    fileName: data.value.upload.fileName,
    columns: data.value.upload.columns,
    rows: data.value.upload.rows,
    countryCode: countryCode ?? data.value.upload.countryCode,
    onClose,
    getInitData: () => ({
        keys: data.value.upload.keys,
        ...data.value.build,
        modification: {
            replaces: [],
            adds: [],
            deletes: [],
            ...data.value.build?.modification,
        },
    }),
    onNext: (build) => {
        stateChangeNestedValue(data, ["build"], () => build);
        onNext();
    },
    onBack: () => {
        stateChangeNestedValue(data, ["upload"], () => null);
    },
});

const Step3 = ({data, officeId, onClose, countryCode}) => Step3CassResult({
    data,
    officeId,
    fileName: data.value.upload.fileName,
    onClose,
    countryCode,
});
